export default __webpack_public_path__ + "static/media/Proxy-mWeb.7673d35b.png";